<template>
  <Dialog ref="dialog">
    <div class="panel panel-collapse">
      <div class="panel__content">
        <div class="panel__heading">
          <h2>Send Text</h2>
        </div>
        <form class="form" @submit="sendText" autocomplete="off">
          <div class="form-group">
            <label class="form-label">Confirm Phone Number in International Format (Example for the US +1XXXXXXXXXX):
              <input v-model="formData.phone" class="form-control">
            </label>
          </div>
          <div class="form-group">
            <label class="form-label">Message:
              <textarea v-model="formData.message" class="form-control form-control--textarea" rows="20"></textarea>
            </label>
          </div>
          <div class="buttons">
            <button type="submit" class="btn btn--primary"
                    :disabled="formData.phone == null || formData.message == null">
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  </Dialog>
</template>

<script>
import Dialog from './Dialog';
import api from '@/api';

export default {
  props: {
    customerId: {
      type: Number
    },
    phone: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
  },
  name: 'CustomerText',
  components: {
    Dialog
  },
  methods: {
    sendText(e) {
      e.preventDefault();

      api.sendText({
        number: this.formData.phone,
        content: this.formData.message,
        customer_id: this.customerId.toString()
      }).catch(err => {
        console.warn(err);
      });

      this.$refs.dialog.$el.classList.remove('show');
    }
  },
  data() {
    return {
      formData: {
        phone: this.phone,
        message: `${this.name}, this is the concierge service reaching out from Aimé Leon Dore. To ensure you continue to receive our product deliveries, please click the link below to verify or update your personal information. This will assist us in staying up-to-date on your sizing and delivery preferences. Thank you!`
      }
    }
  }
}
</script>
